import { render, staticRenderFns } from "./bindmemberinfo.vue?vue&type=template&id=6310c638&scoped=true&"
import script from "./bindmemberinfo.vue?vue&type=script&lang=js&"
export * from "./bindmemberinfo.vue?vue&type=script&lang=js&"
import style0 from "./bindmemberinfo.vue?vue&type=style&index=0&id=6310c638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310c638",
  null
  
)

export default component.exports